<!-- 选择商品类型 -->
<template>
    <div id="goodType">
        <div>
            <el-tree :data="data"
                     :props="defaultProps"
                     default-expand-all
                     :render-content="renderContent"
                     @node-click="handleNodeClick">
            </el-tree>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        components: {

        },
        data(){
            return {
                data:[],
                defaultProps: {
                    children: 'Children',
                    label: 'Name'
                }
            }
        },
        mounted(){
            this.getTableData()
        },
        methods:{
            renderContent(h, { node, data, store }){
                return (
                    <span class="custom-tree-node">
                    <span>{data.Item.Name}</span>
                    </span>
                );
            },
            handleNodeClick(data,node,ele){
                if (data.Children[0]){
                    return
                }
                this.$emit('getGoodsType',data)
            },
            // 加载选择商品类型
            getTableData(){
                this.axios.get('/ERPGood/LoadGoodCategories')
                    .then((response)=> {
                        this.data = response.data.data
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
        }
    }
</script>
<style lang="less" scoped>
    .push-title{
        font-size: @font-sm;
        font-weight: bold;
        margin-bottom: 20px;
        padding-left: 10px;
    }
    .customer-item {
        cursor: pointer;
        padding: 10px;
        border-bottom: 1px solid @border4Color;
        &:hover {
            background: @border4Color;
        }
    }
</style>
